import(/* webpackMode: "eager" */ "/codebuild/output/src1823748998/src/apps/fanychance/src/app/error.tsx");
